export default __webpack_public_path__ + "static/media/Belief.6f14f477.jpg";